var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart2 = function SvgHeart2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#050506",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.727,
    d: "M32.062 10.395a6.83 6.83 0 0 1 .224 9.423L20 33.333 7.714 19.818a6.83 6.83 0 0 1 .224-9.423c2.878-2.878 7.618-2.615 10.161.564L20 13.334l1.9-2.376c2.542-3.178 7.284-3.44 10.162-.563"
  })));
};
export default SvgHeart2;